import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  AlertCircle,
  Loader2,
  Package
} from 'lucide-react';
import { useQuote } from '@/hooks/useQuote';
import { QuoteData } from '@/services/quoteService';
import CarritoStep from '@/components/eleccion/steps/CarritoStep';
import Footer from '@/components/Footer';

export default function QuoteView() {
  const { quoteId } = useParams<{ quoteId: string }>();
  const navigate = useNavigate();
  const { loadQuote } = useQuote();
  const [quote, setQuote] = useState<QuoteData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadQuoteData = async () => {
      if (!quoteId) {
        setError('ID de cotización no válido');
        setLoading(false);
        return;
      }

      try {
        const data = await loadQuote(quoteId);
        if (data) {
          setQuote(data);
        } else {
          setError('Cotización no encontrada o expirada');
        }
      } catch (err) {
        setError('Error al cargar la cotización');
        console.error('Error loading quote:', err);
      } finally {
        setLoading(false);
      }
    };

    loadQuoteData();
  }, [quoteId, loadQuote]);

  if (loading) {
    return (
      <div className="flex flex-col min-h-[calc(100vh-80px)] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
        <p className="text-muted-foreground">Cargando cotización...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col min-h-[calc(100vh-80px)] items-center justify-center px-4">
        <div className="max-w-md text-center">
          <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-foreground mb-2">
            Error al cargar cotización
          </h1>
          <p className="text-muted-foreground mb-6">{error}</p>
          <Button onClick={() => navigate('/')} className="w-full">
            Volver al inicio
          </Button>
        </div>
      </div>
    );
  }

  if (!quote) {
    return (
      <div className="flex flex-col min-h-[calc(100vh-80px)] items-center justify-center px-4">
        <div className="max-w-md text-center">
          <Package className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-foreground mb-2">
            Cotización no encontrada
          </h1>
          <p className="text-muted-foreground mb-6">
            La cotización que buscas no existe o ha expirado.
          </p>
          <Button onClick={() => navigate('/')} className="w-full">
            Crear nueva cotización
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-[calc(100vh-80px)] overflow-x-hidden">
      <div className="flex-1 max-w-none">
        <div className="max-w-4xl mx-auto px-4">
          {/* Cart Display using CarritoStep */}
          <CarritoStep quote={quote} />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}